// Board types
export const BOARD_TYPES = {
  MISSOES: 'missoes',
  CONVITES: 'convites'
};

// Default column configurations for different board types
export const DEFAULT_COLUMNS = {
  [BOARD_TYPES.CONVITES]: {
    1: {
      id: 1,
      uid: '1',
      name: 'A convidar',
      style: { background: '#f5f5f5', color: '#000' },
      cards: []
    },
    2: {
      id: 2,
      uid: '2', 
      name: 'Convidando',
      style: { background: '#f5f5f5', color: '#1890ff' },
      cards: []
    },
    3: {
      id: 3,
      uid: '3',
      name: 'Agendado', 
      style: { background: '#f5f5f5', color: '#faad14' },
      cards: []
    },
    4: {
      id: 4,
      uid: '4',
      name: 'Concluído',
      style: { background: '#f5f5f5', color: '#52c41a' },
      cards: []
    }
  },
  [BOARD_TYPES.MISSOES]: {
    1: {
      id: 1,
      uid: '1',
      name: 'Pendente',
      style: { background: '#f5f5f5', color: '#000' },
      cards: []
    },
    2: {
      id: 2,
      uid: '2',
      name: 'Em progresso',
      style: { background: '#f5f5f5', color: '#faad14' },
      cards: []
    },
    3: {
      id: 3,
      uid: '3',
      name: 'Concluído',
      style: { background: '#f5f5f5', color: '#52c41a' },
      cards: []
    }
  }
};

// Board ID mapping
export const BOARD_ID_MAP = {
  [BOARD_TYPES.MISSOES]: 1,
  [BOARD_TYPES.CONVITES]: 2
};